import { logger } from "../../utils/logger";
// Analytics provider component that initializes analytics from backend settings
import { useEffect } from "react";
import { analytics } from "../../utils/analytics";
import type { AnalyticsConfig } from "../../utils/analytics";
import { unifiedApiService } from "../../services/unified";

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  useEffect(() => {
    const initializeAnalytics = async () => {
      try {
        // Fetch analytics settings from backend
        const settings = await unifiedApiService.system.getPublicSettings();

        // Extract analytics configuration
        const config: AnalyticsConfig = {
          enabled: settings.analytics_enabled?.value === "true",
          googleAnalyticsId: settings.analytics_google_analytics_id?.value,
          googleTagManagerId: settings.analytics_google_tag_manager_id?.value,
          cookieConsentRequired:
            settings.analytics_cookie_consent_required?.value === "true",
        };

        // Initialize analytics with configuration
        await analytics.initialize(config);

        logger.log("[AnalyticsProvider] Analytics initialized:", config);
      } catch (error) {
        logger.error(
          "[AnalyticsProvider] Failed to initialize analytics:",
          error,
        );
        // Continue without analytics
      }
    };

    initializeAnalytics();
  }, []);

  // Don't block rendering while initializing
  return <>{children}</>;
}
